import { render, staticRenderFns } from "./CardEditor.vue?vue&type=template&id=07c3a466&scoped=true&lang=pug"
import script from "./CardEditor.vue?vue&type=script&lang=js"
export * from "./CardEditor.vue?vue&type=script&lang=js"
import style0 from "./CardEditor.vue?vue&type=style&index=0&id=07c3a466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3a466",
  null
  
)

export default component.exports